// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2PHLW","subheader":"ReorderModal_subheader__1TlLZ","listWrap":"ReorderModal_listWrap__1lNtZ"};